import React, { Fragment, useEffect, useState } from "react";
// Import Translate Libraries
import { useHistory } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
// Import UseSelector Hooks
import { useDispatch, useSelector } from "react-redux";

// Import Material UI and React-Bootstrap Components
import { Grid, TextField } from "@material-ui/core";
// Import Datetime Picker Material UI Component
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
// Import Material UI Icons and React Icons
import { IoIosCalendar } from "react-icons/io";
// Import React-Phone-Input Npm Library
import PhoneInput from "react-phone-input-2";
// Import Moment Npm Library
import moment from "moment";
// Import Utilities Functionalities
import { classes } from "../../utils/styledClasses";
// Import Additional Libraries
import { SignalCellularNullRounded } from "@material-ui/icons";
import { Alert } from "react-bootstrap";
import { registrationStyle } from "../../utils/StaticRegistration/registrationStyle";
import AddressInput from "../AddressInput";

import './staticFormAppView.scss'
import { getStakeholderByIdOrVoen, updateStakeholder } from "services/Stakeholder";
import { setCurrentStakeholder } from "redux/features/stakeholder/stakeholderSlice";
import { toast } from "react-toastify";
import { useSnackbar } from "notistack";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import './staticFormAppView.scss'
import getFile from "../../../services/sharedService";
import { width } from "@mui/system";

const StaticFormAppView = () => {
    const intl = useIntl();
    const dispatch = useDispatch()
    const history = useHistory();

    const { enqueueSnackbar } = useSnackbar();

    const { person } = useSelector((state) => state.login);

    const [formikPhoto, setFormikPhoto] = React.useState([]);


    // Redux
    const { currentStakeholder, structureName } = useSelector(
        (state) => state.stakeholder
    );


    const initialValues = {
        requisite: {
            correspondingAccount: "",
            iban: "",
            bankName: "",
            bankCode: "",
            bankTin: "",
            swift: "",
            voen: "",
        },
    };


    // Validation Schema
    const validationSchema = Yup.object({
        correspondingAccount: Yup.string()
            .required(<FormattedMessage id="validation.correspondingAccountRequired" />)
            .min(20, <FormattedMessage id="validation.correspondingAccountMin" />)
            .matches(/^[a-zA-ZƏÖÜÇŞĞIəöüçşğı0-9\s\-\.,\"'&]*$/, intl.formatMessage({ id: 'validation.wrong' }))
            .max(34, <FormattedMessage id="validation.correspondingAccountMax" />),
        iban: Yup.string()
            .required(<FormattedMessage id="validation.ibanRequired" />)
            .matches(/^[a-zA-ZƏÖÜÇŞĞIəöüçşğı0-9\s\-\.,\"'&]*$/, intl.formatMessage({ id: 'validation.wrong' }))
            .length(28, <FormattedMessage id="validation.ibanMin" />),
        bankName: Yup.string()
            .required(<FormattedMessage id="validation.bankNameRequired" />)
            .matches(/^[a-zA-ZƏÖÜÇŞĞIəöüçşğı0-9\s\-\.,\"'&]*$/, intl.formatMessage({ id: 'validation.wrong' }))
            .min(3, <FormattedMessage id="validation.bankNameMin" />)
            .max(255, "too big", <FormattedMessage id="validation.wrong" />),
        bankCode: Yup.string()
            .required(<FormattedMessage id="validation.bankCodeRequired" />)
            .length(6, <FormattedMessage id="validation.bankCodeMin" />)
            .test('is-numeric', <FormattedMessage id="validation.onlyNumbers" />, value => /^[0-9]+$/.test(value)),
        bankTin: Yup.string()
            .required(<FormattedMessage id="validation.bankTinRequired" />)
            .length(10, <FormattedMessage id="validation.bankTinMin" />)
            .test('is-numeric', <FormattedMessage id="validation.onlyNumbers" />, value => /^[0-9]+$/.test(value)),
        swift: Yup.string()
            .required(<FormattedMessage id="validation.swiftRequired" />)
            .matches(/^[a-zA-Z0-9]*$/, intl.formatMessage({ id: 'validation.wrong' }))
            .min(8, <FormattedMessage id="validation.swiftMin" />)
            .max(11, <FormattedMessage id="validation.swiftMax" />),
        voen: Yup.string()
            .required(<FormattedMessage id="validation.voenRequired" />)
            .test('is-numeric', <FormattedMessage id="validation.onlyNumbers" />, value => /^[0-9]+$/.test(value))
            .length(10, <FormattedMessage id="validation.voenMin" />),
    });


    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const transformedValues = {
                ...values,
                correspondingAccount: values.correspondingAccount?.toUpperCase(),
                swift: values.swift?.toUpperCase(),
            };

            const response = await updateStakeholder(currentStakeholder?._id, {
                requisite: transformedValues,
            });
            const updatedStakeholder = response?.data || response;
            dispatch(setCurrentStakeholder(updatedStakeholder));
            enqueueSnackbar(
                intl.formatMessage({ id: 'notify.update_success_message' }),
                { variant: 'success' }
            );
        } catch (error) {
            console.error('Error updating stakeholder:', error);
            enqueueSnackbar(
                intl.formatMessage({ id: 'message.error.stakeholder' }),
                { variant: 'error' }
            );
        } finally {
            setSubmitting(false);
        }
    };

    // function setPhotoPriority(index, e) {
    //     let toIndex = 0;
    //     let element = currentStakeholder?.photo?.[index];
    //     let g1 = currentStakeholder?.photo?.splice(toIndex, 0, element);

    //     setFormikPhoto(g1);

    //     return currentStakeholder?.photo;
    // }

    function setPhotoPriority(index, e) {
        const element = currentStakeholder?.photo?.[index];
        if (!element) return;

        // Create a new array with the selected photo at the front
        const updatedPhotos = [
            element,
            ...currentStakeholder?.photo?.slice(0, index),
            ...currentStakeholder?.photo?.slice(index + 1),
        ];

        setFormikPhoto(updatedPhotos);
    }



    const renderGradeApplicationDetails = (currentStakeholder) => {
        return (
            <div className="container-fluid">
                <div className="d-flex flex-row justify-content-between">
                    {/* <div className="flex-column-auto offcanvas-mobile w-250px w-xxl-350px" id="kt_profile_aside">
                        <div className="card card-custom card-stretch">
                            <div className="card-body pt-4">
                                <div className="d-flex align-items-center">
                                    <div className="w-100">


                                        <div mustbe comment
                                            className="font-weight-bolder font-size-h5 text-dark-75"
                                            style={{ textAlign: "center", marginBottom: "10px" }}
                                        >
                                            {currentStakeholder?.voen
                                                ? currentStakeholder?.brandName
                                                : person?.name + " " + person?.surname + " " + person?.patronymic}
                                        </div>
                                        
                                        <div className="text-muted" style={{ textAlign: "center" }}>
                                            {currentStakeholder.voen ? (
                                                <>
                                                    <FormattedMessage id="voen" />
                                                    {" : "}
                                                    {currentStakeholder?.voen}
                                                </>
                                            ) : (
                                                <>
                                                    <FormattedMessage id="pin" />
                                                    {" : "}
                                                    {person?.pin}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="py-8">
                                    <div className="mb-2">
                                        <span className="font-weight-bold mr-2" style={classes.span}>
                                            <FormattedMessage id="label.uniqueId" />
                                            {" :"}
                                        </span>
                                        <span className="text-muted" style={classes.span}>
                                            {currentStakeholder?.uniqueId}
                                        </span>
                                    </div>

                                    <div className="mb-2">
                                        <span className="font-weight-bold mr-2" style={classes.span}>
                                            <FormattedMessage id="label.createdDate" />
                                            {" :"}
                                        </span>
                                        <span className="text-muted" style={classes.span}>
                                            {moment(currentStakeholder?.createdAt).format("DD MMMM YYYY HH:mm")}
                                        </span>
                                    </div>

                                    <div>
                                        {currentStakeholder?.industryCategory !== null ? (
                                            <>
                                                <span className="font-weight-bold mr-2" style={classes.span}>
                                                    <FormattedMessage id="header.industry_category" />
                                                    {" :"}
                                                </span>
                                                <span className="text-muted" style={classes.span}>
                                                    {currentStakeholder?.industryCategory?.name[intl.locale]}
                                                </span>
                                            </>
                                        ) : null}

                                        {currentStakeholder?.industrySubCategory !== null ? (
                                            <>
                                                <span className="font-weight-bold mr-2" style={classes.span}>
                                                    <FormattedMessage id="header.industry_sub_category" />
                                                    {" :"}
                                                </span>
                                                <span className="text-muted" style={classes.span}>
                                                    {currentStakeholder?.industrySubCategory?.name[intl.locale]}
                                                </span>
                                            </>
                                        ) : null}
                                    </div>

                                    <div className="mt-4">
                                        {currentStakeholder?.status === "REJECTED" ? (
                                            <Alert variant="danger" onClose={null}>
                                                <Alert.Heading>
                                                    <FormattedMessage id="decline.reason" /> {" : "}
                                                </Alert.Heading>
                                                <p>{currentStakeholder?.declineReason}</p>
                                            </Alert>
                                        ) : null}
                                    </div>
                                </div>
                                <hr />
                            </div>
                        </div>
                    </div> */}
                    <div className="col-lg-12 col-12 mt-4 mt-md-0 p-0">
                        <div className="card card-custom card-stretch">
                            <div className="card card-custom card-stretch mb-4">
                                <div className="card-header py-3 d-flex align-items-center">
                                    <div className="card-title align-items-start flex-column">
                                        <h3 className="card-label font-weight-bolder text-dark">
                                            <FormattedMessage id="key_main_information" />
                                        </h3>
                                    </div>
                                </div>
                                <div className="card-body" style={{ color: "red" }}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} md={6} style={classes.rowStyles}>
                                            <TextField
                                                disabled
                                                size="small"
                                                variant="outlined"
                                                id="outlined-basic"
                                                label={
                                                    currentStakeholder?.voen ? (
                                                        <span>
                                                            <FormattedMessage id={"stakeholder.legalName"} />*
                                                        </span>
                                                    ) : (
                                                        <span>
                                                            <FormattedMessage id={"stakeholder.name_name_name"} />
                                                            *
                                                        </span>
                                                    )
                                                }
                                                value={
                                                    currentStakeholder?.name ||
                                                    person?.name +
                                                    " " +
                                                    person?.surname +
                                                    " " +
                                                    person?.patronymic
                                                }
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={6} style={classes.rowStyles}>
                                            <TextField
                                                disabled
                                                id="outlined-disabled"
                                                label={currentStakeholder?.voen ? "Vöen" : "FIN"}
                                                size="small"
                                                variant="outlined"
                                                fullWidth
                                                value={
                                                    currentStakeholder?.voen
                                                        ? currentStakeholder?.voen
                                                        : person?.pin
                                                }
                                            />
                                        </Grid>

                                        {currentStakeholder?.voen &&
                                            currentStakeholder?.industryCategory?.name?.az !== "Bələdçilər" ? (
                                            <>
                                                <Grid item xs={12} sm={6} md={6} style={classes.rowStyles}>
                                                    <TextField
                                                        disabled
                                                        id="outlined-disabled"
                                                        label={
                                                            <span>
                                                                <FormattedMessage
                                                                    id={"stakeholder.legalAddress"}
                                                                />
                                                                *
                                                            </span>
                                                        }
                                                        size="small"
                                                        variant="outlined"
                                                        fullWidth
                                                        value={
                                                            currentStakeholder?.legalAddress ||
                                                            "Məlumat girilməyib"
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={6} style={classes.rowStyles}>
                                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                        <KeyboardDatePicker
                                                            disabled
                                                            fullWidth
                                                            openTo="year"
                                                            size="small"
                                                            margin="none"
                                                            variant="dialog"
                                                            inputVariant="outlined"
                                                            animateYearScrolling={true}
                                                            invalidDateMessage={
                                                                <FormattedMessage id="error.date_invalid" />
                                                            }
                                                            minDateMessage={
                                                                <FormattedMessage id="error.date_min" />
                                                            }
                                                            maxDateMessage={
                                                                <FormattedMessage id="error.date_max" />
                                                            }
                                                            keyboardIcon={<IoIosCalendar />}
                                                            minDate={new Date("1970-01-01")}
                                                            maxDate={Date.now()}
                                                            label={
                                                                <span>
                                                                    <FormattedMessage
                                                                        id={"stakeholder.objectRegistrationDate"}
                                                                    />
                                                                    *
                                                                </span>
                                                            }
                                                            format="dd.MM.yyyy"
                                                            placeholder="dd.MM.yyyy"
                                                            InputAdornmentProps={{ position: "start" }}
                                                            value={
                                                                currentStakeholder?.objectRegisterationDate ||
                                                                "Məlumat girilməyib"
                                                            }
                                                        />
                                                    </MuiPickersUtilsProvider>
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={6} style={classes.rowStyles}>
                                                    <TextField
                                                        disabled
                                                        id="outlined-disabled"
                                                        label={
                                                            <span>
                                                                <FormattedMessage id={"stakeholder.objectName"} />
                                                                *
                                                            </span>
                                                        }
                                                        size="small"
                                                        variant="outlined"
                                                        fullWidth
                                                        value={
                                                            currentStakeholder?.objectName || "Məlumat girilməyib"
                                                        }
                                                    />
                                                </Grid>

                                                {currentStakeholder?.voen?.charAt(
                                                    currentStakeholder?.voen.length - 1
                                                ) === "1" && (
                                                        <Grid item xs={12} sm={6} md={6} style={classes.rowStyles} >
                                                            <TextField
                                                                id="outlined-basic"
                                                                label={
                                                                    <FormattedMessage id="stakeholder.companyGroup" />
                                                                }
                                                                size="small"
                                                                variant="outlined"
                                                                fullWidth
                                                                name="groupofcompanies"
                                                                disabled
                                                                value={
                                                                    currentStakeholder?.groupOfCompanies ||
                                                                    "Məlumat girilməyib"
                                                                }
                                                            />
                                                        </Grid>
                                                    )}
                                                <Grid item xs={12} sm={6} md={6} style={classes.rowStyles} >
                                                    <TextField
                                                        id="outlined-basic"
                                                        label={
                                                            <FormattedMessage id="stakeholder.personInChargeName" />
                                                        }
                                                        size="small"
                                                        variant="outlined"
                                                        fullWidth
                                                        name="personInChargeName"
                                                        disabled
                                                        value={
                                                            currentStakeholder?.personInChargeName ||
                                                            "Məlumat girilməyib"
                                                        }
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={6} style={classes.rowStyles}>
                                                    <TextField
                                                        disabled
                                                        type="text"
                                                        size="small"
                                                        variant="outlined"
                                                        id="outlined-basic"
                                                        label={
                                                            <span>
                                                                <FormattedMessage
                                                                    id={"stakeholder.managerName"}
                                                                />
                                                                *
                                                            </span>
                                                        }
                                                        name="managerName"
                                                        value={
                                                            currentStakeholder?.managerName ||
                                                            "Məlumat girilməyib"
                                                        }
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={6} style={classes.rowStyles} >
                                                    <TextField
                                                        id="outlined-basic"
                                                        label={<FormattedMessage id="stakeholder.city" />}
                                                        size="small"
                                                        variant="outlined"
                                                        fullWidth
                                                        name="city"
                                                        disabled
                                                        value={currentStakeholder?.city || "Məlumat girilməyib"}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={6} md={6} style={classes.rowStyles}>
                                                    <TextField
                                                        disabled
                                                        id="outlined-disabled"
                                                        label={
                                                            <span>
                                                                <FormattedMessage id={"stakeholder.objectCode"} />
                                                                *
                                                            </span>
                                                        }
                                                        size="small"
                                                        variant="outlined"
                                                        fullWidth
                                                        value={
                                                            currentStakeholder?.objectCode || "Məlumat girilməyib"
                                                        }
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={6} md={6} style={{ padding: "30px 15px 5px 0px" }}>
                                                    <PhoneInput
                                                        disabled
                                                        containerClass="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                                                        inputStyle={{
                                                            width: "-webkit-fill-available",
                                                            padding: "10px 14px 8px 50px",
                                                            marginBottom: 2,
                                                            fontSize: 14,
                                                            height: 36,
                                                            borderRadius: 4,
                                                            color: "rgba(0, 0, 0, 0.38)",
                                                        }}
                                                        id="outlined-disabled"
                                                        name="personInChargePhone"
                                                        disableDropdown={true}
                                                        countryCodeEditable={false}
                                                        masks={{ az: "(..) ... .. .." }}
                                                        country={"az"}
                                                        onlyCountries={["az"]}
                                                        value={
                                                            currentStakeholder?.personInChargePhone ||
                                                            "Məlumat girilməyib"
                                                        }
                                                        specialLabel={
                                                            <div
                                                                style={{
                                                                    color: "#000",
                                                                    fontSize: "11px",
                                                                    fontFamily: "Poppins",
                                                                    lineHeight: 1,
                                                                    opacity: "0.4",
                                                                }}
                                                            >
                                                                {
                                                                    <span>
                                                                        <FormattedMessage
                                                                            id={"stakeholder.personInChargePhone"}
                                                                        />
                                                                        *
                                                                    </span>
                                                                }
                                                            </div>
                                                        }
                                                        InputLabelProps={{
                                                            style: { color: "#000" },
                                                        }}
                                                    />
                                                </Grid>
                                                <>
                                                    <Grid item xs={12} sm={6} md={6} style={classes.rowStyles}>
                                                        <TextField
                                                            disabled
                                                            type="text"
                                                            size="small"
                                                            variant="outlined"
                                                            id="outlined-basic"
                                                            label={
                                                                <span>
                                                                    <FormattedMessage
                                                                        id={"stakeholder.brandName"}
                                                                    />
                                                                    *
                                                                </span>
                                                            }
                                                            name="brandName"
                                                            value={
                                                                currentStakeholder?.brandName ||
                                                                "Məlumat girilməyib"
                                                            }
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </>
                                                <Grid item xs={12} sm={6} md={6} style={classes.rowStyles}>
                                                    <TextField
                                                        disabled
                                                        type="text"
                                                        size="small"
                                                        variant="outlined"
                                                        id="outlined-basic"
                                                        label={
                                                            <span>
                                                                <FormattedMessage id={"stakeholder.website"} />*
                                                            </span>
                                                        }
                                                        name="website"
                                                        value={
                                                            currentStakeholder?.website || "Məlumat girilməyib"
                                                        }
                                                        fullWidth
                                                    />
                                                </Grid>
                                                {currentStakeholder?.industryCategory?.name?.az ===
                                                    "Yerləşmə vasitələri" ? (
                                                    <>
                                                        <Grid
                                                            item xs={12} sm={6} md={6}
                                                            style={classes.rowStyles}
                                                            alignItems="center"
                                                        >
                                                            <TextField
                                                                id="outlined-basic"
                                                                label={
                                                                    <span>
                                                                        <FormattedMessage
                                                                            id={"stakeholder.bedCount"}
                                                                        />
                                                                        *
                                                                    </span>
                                                                }
                                                                size="small"
                                                                variant="outlined"
                                                                fullWidth
                                                                disabled
                                                                value={currentStakeholder?.bedCount}
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item xs={12} sm={6} md={6}
                                                            style={classes.rowStyles}
                                                            alignItems="center"
                                                        >
                                                            <TextField
                                                                id="outlined-basic"
                                                                label={
                                                                    <span>
                                                                        <FormattedMessage
                                                                            id={"stakeholder.roomCount"}
                                                                        />
                                                                        *
                                                                    </span>
                                                                }
                                                                size="small"
                                                                variant="outlined"
                                                                fullWidth
                                                                disabled
                                                                value={currentStakeholder?.roomCount}
                                                            />
                                                        </Grid>
                                                    </>
                                                ) : null}
                                            </>
                                        ) : (
                                            <>
                                                <Grid item xs={8} sm={6} md={6} style={classes.rowStyles}>
                                                    <TextField
                                                        disabled
                                                        id="outlined-disabled"
                                                        label={
                                                            <span>
                                                                <FormattedMessage
                                                                    id={"stakeholder.nationality"}
                                                                />
                                                                *
                                                            </span>
                                                        }
                                                        size="small"
                                                        variant="outlined"
                                                        name="nationality"
                                                        fullWidth
                                                        value={
                                                            currentStakeholder?.nationality ||
                                                            "Məlumat girilməyib"
                                                        }
                                                    />
                                                </Grid>
                                                <Grid md={6} style={classes.rowStyles}  >
                                                    <TextField
                                                        id="outlined-basic"
                                                        label={
                                                            <span>
                                                                <FormattedMessage id="stakeholder.address" />*
                                                            </span>
                                                        }
                                                        size="small"
                                                        variant="outlined"
                                                        name="address"
                                                        value={currentStakeholder?.address}
                                                        style={{ width: '100%' }}
                                                    />
                                                </Grid>
                                            </>
                                        )
                                        }
                                        <Grid item xs={12} sm={6} md={6} style={{ ...classes.rowStyles, marginTop: "2px" }}>
                                            <TextField
                                                disabled
                                                type="email"
                                                size="small"
                                                variant="outlined"
                                                id="outlined-basic"
                                                label={
                                                    <span>
                                                        <FormattedMessage id={"stakeholder.email"} />*
                                                    </span>
                                                }
                                                name="email"
                                                value={currentStakeholder?.email || "Məlumat girilməyib"}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={6} style={{ padding: "30px 15px 5px 0px" }}>
                                            <PhoneInput
                                                disabled
                                                containerClass="MuiFormControl-root MuiTextField-root MuiFormControl-fullWidth"
                                                inputStyle={{
                                                    width: "-webkit-fill-available",
                                                    padding: "10px 14px 8px 50px",
                                                    marginBottom: 2,
                                                    marginTop: 2,
                                                    fontSize: 14,
                                                    height: 36,
                                                    borderRadius: 4,
                                                    color: "rgba(0, 0, 0, 0.38)",
                                                }}
                                                id="outlined-disabled"
                                                name="phone"
                                                disableDropdown={true}
                                                countryCodeEditable={false}
                                                masks={{ az: "(..) ... .. .." }}
                                                country={"az"}
                                                onlyCountries={["az"]}
                                                value={currentStakeholder?.phone || "Məlumat girilməyib"}
                                                specialLabel={
                                                    <div
                                                        style={{
                                                            color: "#000",
                                                            fontSize: "11px",
                                                            fontFamily: "Poppins",
                                                            lineHeight: 1,
                                                            opacity: "0.4",
                                                        }}
                                                    >
                                                        <span>
                                                            <FormattedMessage id={"stakeholder.objectPhone"} />*
                                                        </span>
                                                    </div>
                                                }
                                                InputLabelProps={{
                                                    style: { color: "#000" },
                                                }}
                                            />
                                        </Grid>



                                        {currentStakeholder?.voen &&
                                            currentStakeholder?.name?.az !== "Bələdçilər" ? (
                                            <Grid item xs={12} sm={6} md={6} style={classes.rowStyles} >
                                                <AddressInput
                                                    appView={true}
                                                    label={
                                                        <span>
                                                            <FormattedMessage id={"stakeholder.objectAdress"} />*
                                                        </span>
                                                    }
                                                    data={currentStakeholder.objectAddress || {}}
                                                />
                                            </Grid>
                                        ) : null}
                                        {currentStakeholder?.photo?.length > 0 ? (
                                            <Grid item xs={12} sm={6} md={6} style={classes.rowStyles}>
                                                <div style={{ width: "100%" }}>
                                                    <label style={{ marginBottom: 0, marginTop: "-2px", color: "#000000", opacity: "0.5" }}>
                                                    <FormattedMessage id={!currentStakeholder?.voen ? "staticReg_logo" : "staticReg_photo"}/>*
                                                    </label>
                                                    <div style={{ ...registrationStyle.thumbnail_box, marginTop: 0 }}>
                                                        {currentStakeholder?.photo?.map((item, index) => (
                                                            <div
                                                                style={registrationStyle.thumbnail}
                                                                key={index}
                                                                onClick={(e) => setPhotoPriority(index, e)}
                                                            >
                                                                {item?.url
                                                                    ? (
                                                                        <img
                                                                            alt={item?.url}
                                                                            src={getFile.getFile(item?.url)}
                                                                            style={registrationStyle.imgPhoto}
                                                                        />
                                                                    ) : (
                                                                        <img
                                                                            src={
                                                                                item?.base64
                                                                                    ? item?.base64
                                                                                    : URL.createObjectURL(item)
                                                                            }
                                                                            alt={item?.name}
                                                                            style={registrationStyle.imgPhoto}
                                                                        />
                                                                    )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <span>
                                                        <FormattedMessage id="stakeholder.photo" />
                                                    </span>
                                                </div>
                                            </Grid>
                                        ) : null}
                                    </Grid>

                                    {currentStakeholder?.status !== "IN PROGRESS" ? (
                                        <div style={{marginTop:"20px", display: "flex" , width:"100%", justifyContent: "end"}}>
                                            <button
                                                className="form-event-btn col-6 col-lg-3"
                                                onClick={() =>
                                                    !currentStakeholder?.active
                                                        ? history.push("/stakeholder/new/profile-view/edit")
                                                        : history.push(
                                                            "/stakeholder/cabinet/profile-view/edit"
                                                        )
                                                }
                                            >
                                                <FormattedMessage id="button.edit" />
                                            </button>
                                        </div>
                                    ) : null}
                                </div>
                            </div>

                            <div className="card card-custom card-stretch">
                                <div className="card-header py-3 d-flex align-items-center">
                                    <div className="card-title align-items-start flex-column">
                                        <h3 className="card-label font-weight-bolder text-dark">
                                            <FormattedMessage id="app_form_requiset" />
                                        </h3>
                                    </div>
                                </div>
                                <div className="card-body" style={{ color: "red" }}>
                                    <Formik
                                        initialValues={currentStakeholder?.requisite || initialValues}
                                        validationSchema={validationSchema}
                                        onSubmit={handleSubmit}
                                        enableReinitialize
                                    >
                                        {({ values, initialValues, isSubmitting, errors, touched, setFieldValue }) => {

                                            const isFormChanged = JSON.stringify(values) !== JSON.stringify(initialValues)
                                            return (
                                                <Form>
                                                    <Grid container spacing={2}>
                                                        {/* Left Column */}
                                                        <Grid item xs={12} md={6}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12}>
                                                                    <Field
                                                                        as={TextField}
                                                                        name="correspondingAccount"
                                                                        label={<FormattedMessage id="correspondent-account" />}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        inputProps={{ style: { textTransform: 'uppercase' } }}
                                                                        helperText={<ErrorMessage name="correspondingAccount" />}
                                                                        error={Boolean(errors.correspondingAccount && touched.correspondingAccount)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Field
                                                                        as={TextField}
                                                                        name="iban"
                                                                        label={<FormattedMessage id="current-account" />}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        helperText={<ErrorMessage name="iban" />}
                                                                        error={Boolean(errors.iban && touched.iban)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Field
                                                                        as={TextField}
                                                                        name="voen"
                                                                        label={<FormattedMessage id="voen" />}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        helperText={<ErrorMessage name="voen" />}
                                                                        error={Boolean(errors.voen && touched.voen)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Field
                                                                        as={TextField}
                                                                        name="swift"
                                                                        label={<FormattedMessage id="S.W.I.F.T" />}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        inputProps={{ style: { textTransform: 'uppercase' } }}
                                                                        fullWidth
                                                                        helperText={<ErrorMessage name="swift" />}
                                                                        error={Boolean(errors.swift && touched.swift)}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>

                                                        {/* Right Column */}
                                                        <Grid item xs={12} md={6}>
                                                            <Grid container spacing={2}>
                                                                <Grid item xs={12}>
                                                                    <Field
                                                                        as={TextField}
                                                                        name="bankName"
                                                                        label={<FormattedMessage id="bank_name" />}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        helperText={<ErrorMessage name="bankName" />}
                                                                        error={Boolean(errors.bankName && touched.bankName)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Field
                                                                        as={TextField}
                                                                        name="bankCode"
                                                                        label={<FormattedMessage id="bank_code" />}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        helperText={<ErrorMessage name="bankCode" />}
                                                                        error={Boolean(errors.bankCode && touched.bankCode)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <Field
                                                                        as={TextField}
                                                                        name="bankTin"
                                                                        label={<FormattedMessage id="bank_tin" />}
                                                                        size="small"
                                                                        variant="outlined"
                                                                        fullWidth
                                                                        helperText={<ErrorMessage name="bankTin" />}
                                                                        error={Boolean(errors.bankTin && touched.bankTin)}
                                                                    />
                                                                </Grid>
                                                                <Grid item xs={12}>
                                                                    <button
                                                                        type="submit"
                                                                        className={`form-event-btn ml-auto  w-50 ${isSubmitting || !isFormChanged || Object.keys(errors).length > 0 ? 'disabled' : ''}`}
                                                                        disabled={isSubmitting || !isFormChanged}
                                                                    >
                                                                        <FormattedMessage id="button.save" />
                                                                    </button>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Form>
                                            )
                                        }}
                                    </Formik>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Fragment>
            {currentStakeholder
                ? renderGradeApplicationDetails(currentStakeholder)
                : null}
        </Fragment>
    );
};

export default StaticFormAppView;
